import React, { Component } from 'react'
import { translate } from '../../utils/useful'
import IntractionActionsList from '../IntractionActionsList'
import importedIcons from '../inputs/icons'

export default class SendToMain extends Component {
    render() {
        return (
            <div>
                <div className="pb-2">
                    <button className="flexc w-100 hover-gray p-2 br-10" onClick={this.props.lastPage}  >
                        <img width={18} src={importedIcons.arrowLeft} className="rtl-button" />
                        <p className="font-size-13 weight-500 mld-3 main-c3 text-start">  {translate("Send To")}  </p>
                    </button>
                </div>
                {this.props.actions && Object.values(this.props.actions).map((prop, index) => {
                    return (
                        <IntractionActionsList onClick={() => this.props.actionClicked(prop, this.props.data, this.props.index)} language={this.props.language} data={{ title: prop.label, sub: prop.sub, shortcut: null, sub: true, icon: prop.icon }} />
                    )
                })}

            </div>
        )
    }
}
